export default "__VITE_ASSET__57fad8a7__"